import { InfoCard, Avatar, Caption, Slot } from '@costar-ui/components';
import React from 'react';
import Skeletons from '../../card-details/skeletons.esm.js';
import { Details } from '../../card-details/details.esm.js';

var ContactCardSectionGhostDense = function ContactCardSectionGhostDense(props) {
  var photo = props.photo,
    removeAvatar = props.removeAvatar,
    name = props.name,
    jobTitle = props.jobTitle,
    phone = props.phone,
    mailtoLink = props.mailtoLink,
    socialIconLinks = props.socialIconLinks,
    isLoading = props.isLoading,
    testId = props.testId,
    responsive = props.responsive;
  return /*#__PURE__*/React.createElement(InfoCard, {
    variant: "ghost-dense",
    className: "csg-tw-contact-card-section-ghost-dense",
    testId: testId,
    responsive: responsive
  }, !removeAvatar && photo !== null && photo !== void 0 && photo.src ? /*#__PURE__*/React.createElement(Avatar, {
    size: "sm",
    src: photo === null || photo === void 0 ? void 0 : photo.src,
    title: name === null || name === void 0 ? void 0 : name.label,
    alt: name === null || name === void 0 ? void 0 : name.label,
    testId: "contact-image"
  }) : null, /*#__PURE__*/React.createElement(Caption, {
    testId: "contact-details",
    responsive: responsive
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeletons, {
    height: "1.5"
  }), /*#__PURE__*/React.createElement(Skeletons, {
    num: 3
  }), /*#__PURE__*/React.createElement(Slot, {
    alignItems: "center",
    gap: "sm",
    className: "csg-tw-skeleton-social-icon-links"
  }, /*#__PURE__*/React.createElement(Skeletons, {
    num: 2,
    width: "1.25"
  }))) : /*#__PURE__*/React.createElement(Details, {
    name: name,
    jobTitle: jobTitle,
    phone: phone,
    mailtoLink: mailtoLink,
    socialIconLinks: socialIconLinks,
    isLoading: isLoading
  })));
};
var ContactCardSectionGhostDense$1 = ContactCardSectionGhostDense;

export { ContactCardSectionGhostDense, ContactCardSectionGhostDense$1 as default };
//# sourceMappingURL=contact-card-section-ghost-dense.esm.js.map
